import React from 'react';
import ReactDOM from 'react-dom/client';

// 1. Import des styles globaux (Bootstrap + votre custom CSS)
import './assets/styles/index.css';


// 3. Import du composant principal
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/**
 * Mesure des performances de l'application.
 * Les résultats peuvent être envoyés à un service d'analyse.
 */
reportWebVitals();